"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyTradingDataRequest = void 0;
var MyTradingDataRequest = /** @class */ (function () {
    function MyTradingDataRequest() {
    }
    return MyTradingDataRequest;
}());
exports.MyTradingDataRequest = MyTradingDataRequest;
;
//# sourceMappingURL=myTradingData.request.js.map